<!-- Footer -->
<footer class="container footer page-footer font-small blue pt-4">

    <!-- Footer Links -->
    <div class="container-fluid text-center text-md-left">
  
      <!-- Grid row -->
      <div id="contact" class="row ">
  
        <!-- Grid column -->
        <div class="col-md-6 mt-md-0 mt-3">
  
          <!-- Content -->
          <h5 class="poppins">Contact</h5>
          <p class="poppins-extralight">Address :57/1 M.9  Banglane Bangyai Nonthaburi 11140 <br>
            Telephone : +66 (9) 791 991 93  +66 (8) 863 571 263 <br>
            Email : sales@hayes-chem.com </p>
  
        </div>
        <!-- Grid column -->
  
        <hr class="clearfix w-100 d-md-none pb-3">
  
        <!-- Grid column -->
        <div class="col-md-3 mb-md-0 mb-3">
  
          <!-- Links -->
          <h5 class="poppins">Follow</h5>
  
          <ul class="list-unstyled poppins-extralight">
            <li>
              <a href="https://www.google.com/maps/place/Soi+Thong+Pan+19,+Tambon+Bang+Len,+Amphoe+Bang+Yai,+Chang+Wat+Nonthaburi+11140/@13.847089,100.427108,16.32z/data=!4m5!3m4!1s0x30e29072eecbeaed:0x7c9cc3ac41bfc9b1!8m2!3d13.8504816!4d100.4298797">Map</a>
            </li>
            <li>
              <a href="https://line.me/R/ti/p/%40774gqmmw">Line</a>
            </li>
            <li>
              <a href="https://www.facebook.com/Hayes-chemical-industry-101223734794821">Facebook</a>
            </li>
          </ul>
  
        </div>
        <!-- Grid column -->

        
        <!-- Grid column -->
        <div class="col-md-3 mb-md-0 mb-3">

            <div class="row" >
                <div>
                    <img src="assets/img/footer/barcode.png" class="rounded float-left img-fluid" alt="hayes.com">
                </div>
            </div>
            <div class="row">
                <img src="assets/img/footer/logo.png" class="rounded float-left img-fluid" alt="hayes.com">
            </div>
    
          </div>
          <!-- Grid column -->
  
      </div>
      <!-- Grid row -->
  
    </div>
    <!-- Footer Links -->
  
    <!-- Copyright -->
    <div class="footer-copyright text-center py-3">© 2020 Copyright:
      <a href="https://hayes-chem.com/"> hayes-chem.com</a>
    </div>
    <!-- Copyright -->
  
  </footer>
  <!-- Footer -->